exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".typography___base___3N10T {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-size: 13px;\n}\n\n.typography___special___uNCwP {\n    color: white;\n    text-transform: uppercase;\n    font-family: \"Oscine\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\n.typography___normal___57CAh {\n    color: white;\n    font-family: \"Oscine\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}", ""]);

// exports
exports.locals = {
	"base": "typography___base___3N10T",
	"special": "typography___special___uNCwP typography___base___3N10T",
	"normal": "typography___normal___57CAh typography___base___3N10T"
};